import React from 'react';
import { translate } from '../Services/translation';

const PLACEHOLDER_IMAGE_URL = "/ui/images/image-placeholder.png"

const QuickSearchResult = ({ result, showAll, searchUrl }) => {
    if(!result) return null

    var nonSideListKeys = ["products"]
    var products = result["products"]

    return <div className="quick-search-result">
        <div className="row expanded">
            <div className="quick-search-result__main-list small-12 medium-8">
                <h5>{translate("quicksearchheader.products")}</h5>
                {products && <>
                    {products.map(item => 
                        <a href={item.url} key={item.name+item.url} className="quick-search-result__main-list-item">
                            <div className="quick-search-result__image-wrapper">
                                <img src={item.hasImage && item.imageSource ? item.imageSource : PLACEHOLDER_IMAGE_URL} />
                            </div>
                            <p className="text-large text-bold">{item.name}</p>
                        </a>
                    )}
                </>}
                {!products && translate("search.no-matching-products")}
            </div>
            <div className="quick-search-result__side-list-wrapper small-12 medium-4">
                {Object.keys(result).map(key => {
                    if(nonSideListKeys.includes(key)) return

                    var items = result[key]
                    return <div className="quick-search-result__side-list" key={key}>
                        <h5>{items[0].category}</h5>
                        <div className="quick-search-result__side-list-items">
                            {items.map(item => <a href={item.url} key={item.name+item.url}>{item.name}</a>)}
                        </div>
                    </div>
                })}
            </div>
        </div>
        {showAll && 
            <div className="row expanded">
                <div className="quick-search-result__show-all">
                    <a className="btn btn--primary btn--fullwidth" href={searchUrl}>{showAll.name}</a>
                </div>
            </div>
        }
    </div>
}

export default QuickSearchResult;